<app-simulation-banner></app-simulation-banner>
<app-header *ngIf="showHeader"
  [title]="title"
  [subtitle]="'Versão: 0.0'"
  [signature]="'Ministério da Saúde'"
></app-header>
<app-title></app-title>

<app-loading></app-loading>
<app-global-message></app-global-message>

<div class="container-lg mb-4">
  <br-breadcrumb
    *ngIf="crumbs.length > 0"
    [crumbs]="crumbs"
    [homeUrl]="'/home'"
  ></br-breadcrumb>

  <router-outlet />
</div>

<br-footer *ngIf="showFooter" [socialNetworkTitle]="''">
  <br-footer-legal class="w-100"
    >MS | Secretaria de Gestão do Trabalho e da Educação na Saúde - SGTES</br-footer-legal
  >
</br-footer>
